var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "a",
    {
      class: _vm.classActive,
      attrs: {
        href: _vm.url,
      },
      on: {
        click: _vm.handleClick,
      },
    },
    [
      _vm.notifications > 0
        ? _c(
            "v-badge",
            {
              attrs: {
                bordered: "",
                overlap: "",
                content: _vm.notifications,
                color: "red",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "w-100 text-yellow",
                },
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        color: "amber",
                      },
                    },
                    [_vm._v("mdi-bell")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "py-0 my-1 text-lg mt-2",
                    },
                    [_vm._v("อัพเดต")]
                  ),
                ],
                1
              ),
            ]
          )
        : _c(
            "div",
            {
              staticClass: "w-100 text-yellow",
            },
            [
              _c(
                "v-icon",
                {
                  attrs: {
                    color: "amber",
                  },
                },
                [_vm._v("mdi-bell")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "py-0 my-1 text-lg mt-2",
                },
                [_vm._v("อัพเดต")]
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }